import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../config/themeTokens';

const StyledButton = styled.button`
  font-family: ${tokens.typography.fontFamilyHeading};
  font-size: ${tokens.typography.sizeBase};
  font-weight: ${tokens.typography.weightMedium};
  padding: ${tokens.spacing.sm} ${tokens.spacing.lg};
  border-radius: ${tokens.radius.md};
  border: none;
  cursor: pointer;
  background-color: ${({ $variant }) => ($variant === 'secondary' ? 'transparent' : tokens.colors.primary)};
  color: ${({ $variant }) => ($variant === 'secondary' ? tokens.colors.primary : tokens.colors.background)};
  border: ${({ $variant }) => ($variant === 'secondary' ? `2px solid ${tokens.colors.primary}` : 'none')};

  &:hover {
    opacity: 0.9;
  }
`;

export function Button({ variant = 'primary', children, ...props }) {
  return (
    <StyledButton $variant={variant} {...props}>
      {children}
    </StyledButton>
  );
}

export default Button;
